document.addEventListener('rebuy:smartcart.ready', () => {
  let rebuyWidget = document.getElementById('rebuy-cart');

  if (rebuyWidget && window.innerWidth <= 750) {
    let rebuyWidgetFlyout = rebuyWidget.querySelector('.rebuy-cart__flyout-content');
    let cartRecommendations = document.querySelector('.rebuy-cart__flyout-recommendations');

    if (cartRecommendations) {
      cartRecommendations.remove();
      rebuyWidgetFlyout.appendChild(cartRecommendations);
    }
  }
  
  //AB-TEST
  if (rebuyWidget) {
    const firstName = document.body.dataset.firstName ? `${document.body.dataset.firstName}` : 'Bulbheader';
    document.addEventListener('rebuy:cart.change', function(event){
      const settings = window.Rebuy.SmartCart.settings;
      const dataBundle = window.Rebuy.Cart.cart.items.reduce((acc, item) => {
        if(item.properties.custom_bundle){
          return acc + 1
        }
        return acc
      }, 0)
      const isBundle = dataBundle >= 3 ? true : false
        const cartTotal = window.Rebuy.Cart.cart.total_price;
        if(isBundle){
          settings.free_shipping.minimum = 0
          settings.language.free_shipping_reached = `🎉 Bundle Promo Congrats! You've unlocked <b>FREE SHIPPING</b>, ${firstName}`;
        }else if (cartTotal >= 5000) {
            settings.language.free_shipping_reached = `🎉 Congrats! You've unlocked <b>FREE SHIPPING</b>, ${firstName}`;
        } else {
            settings.free_shipping.minimum = 5000;
            settings.language.free_shipping_remaining = `You are {{remaining_amount}} away from <b>FREE SHIPPING</b>, ${firstName}`;
        }
    });
  };
});
document.addEventListener('rebuy.productsChange', function (event) {
  setTimeout(() => {
    const products = event.detail.products;
    const widget_container = document.querySelector(`#rebuy-cart [data-rebuy-id="${event.detail.widget.id}"]`);
    if (widget_container != null) {
      widget_container.querySelectorAll('.rebuy-product-description-custom').forEach(description => {
        description.remove();
      })
      products.forEach((product, index) => {
        const product_grid = widget_container.querySelector(`.product-id-${product.id} .rebuy-product-info`);
        const rendered_description_container = product_grid.querySelector(`.rebuy-product-description-custom`);
        if (product_grid != null && product.metafields.global.upsell_description != undefined && rendered_description_container === null) {
          const description_container = document.createElement('p');
          description_container.classList = 'rebuy-product-description-custom';
          description_container.innerText = product.metafields.global.upsell_description;
          product_grid.appendChild(description_container);
        }
      });
    }
  }, 150);
});
document.addEventListener('rebuy.productsChange', function (event) {
  setTimeout(() => {
    const products = event.detail.products;
    const widget_container = document.querySelector(`#rebuy-cart [data-rebuy-id="${event.detail.widget.id}"]`);
    if (widget_container != null) {
      widget_container.querySelectorAll('.rebuy-product-description-custom').forEach(description => {
        description.remove();
      })
      products.forEach((product, index) => {
        const product_grid = widget_container.querySelector(`.product-id-${product.id} .rebuy-product-info`);
        const rendered_description_container = product_grid.querySelector(`.rebuy-product-description-custom`);
        if (product_grid != null && product.metafields.global.upsell_description != undefined && rendered_description_container === null) {
          const description_container = document.createElement('p');
          description_container.classList = 'rebuy-product-description-custom';
          description_container.innerText = product.metafields.global.upsell_description;
          product_grid.appendChild(description_container);
        }
      });
    }
  }, 150);
});